const autocompleteModalDocEmployee = {
  documentTypes: 'Tipo do Documento',
  document: 'Documento'
};

export default autocompleteModalDocEmployee;
